import { NavLink } from "react-router-dom"
import useOrientation from "@/hooks/useOrientation"

import TitleS from "@/components/text/title-s"
import TextBoldM from "@/components/text/text-bold-m"
import TextRegularM from "@/components/text/text-regular-m"

import { ARTIST } from "@/data"

type AlbumData = {
  imgUrl: string
  title: string
  type: string
  artist: string
  artistImgUrl: string
}

type Props = {
  data: AlbumData
  duracionTotal: string
  artistBio?: string
}

export default function PlaylistDetails({
  data,
  duracionTotal,
}: Props) {
  const { isPortrait, isLandscape, isStandalone } = useOrientation()

  const findArtistLink = (artistName: string) => {
    const artist = ARTIST.find(
      (item) =>
        item.artist.toLowerCase() ===
        artistName.toLowerCase()
    )

    return artist
      ? `/artist/${artist.artist}`
      : "#"
  }

  const artistLink = findArtistLink(data.artist)

  return (
    <div
      className={`
        p-4
        w-full
        grid
        gap-6
        justify-items-center
        text-center
        select-none

        lg:grid-cols-[auto_1fr]
        lg:justify-items-start
        lg:text-left

        ${isPortrait ? "mt-20" : ""}
        ${isStandalone ? "mt-30" : ""}
        ${isLandscape ? "" : ""}
      `}
    >
      {/* COVER */}

      <div
        className="
          w-44
          min-h-44
          rounded-2xl
          bg-black/50
          transition-transform
          duration-200
          active:scale-105
          lg:hover:scale-[1.02]
        "
      >
        <img
          src={data.imgUrl}
          alt={data.title}
          className="
            w-full
            h-auto
            rounded-2xl
            shadow-[0_50px_45px_rgba(0,0,0,.5)]
          "
        />
      </div>

      {/* INFO */}

      <div
        className="
          flex
          flex-col
          justify-end
          items-center
          lg:items-start
        "
      >
        <TitleS>{data.type}</TitleS>

        <h1
          className="
            mt-1
            text-[30px]
            leading-[30px]
            font-bold

            lg:text-[5rem]
            lg:leading-[6rem]
            lg:tracking-[-0.04rem]

            line-clamp-2
          "
        >
          {data.title}
        </h1>

        <div
          className="
            mt-4
            flex
            items-center
            justify-center
            gap-2

            lg:justify-start
          "
        >
          <NavLink
            to={artistLink}
            className="
              flex
              items-center
              gap-2

              rounded-full

              bg-zinc-100
              text-black

              px-1
              py-1

              transition-transform
              duration-300

              active:scale-95
              lg:hover:scale-[0.98]
            "
          >
            <figure
              className="
                w-8
                h-8
                shrink-0
              "
            >
              <img
                src={data.artistImgUrl}
                alt={data.artist}
                className="
                  w-full
                  h-full
                  rounded-full
                  object-cover
                "
              />
            </figure>

            <TextBoldM>
              {data.artist}
            </TextBoldM>
          </NavLink>

          <div
            className="
              flex
              items-center
              justify-center

              min-w-24
              h-10

              rounded-full

              border
              border-white/80

              bg-white/10

              px-3
            "
          >
            <TextRegularM>
              ⌁ {duracionTotal}
            </TextRegularM>
          </div>
        </div>
      </div>
    </div>
  )
}